// eslint-disable-next-line no-redeclare
/* global $ */

var processInclude = require('base/util');

$(document).ready(function () {
    const isCheckout = $("#checkout-main") && $("#checkout-main").length;
    const isKohler = window.location.hostname.includes('kohler');
    if (!isCheckout && !isKohler) {
        processInclude(require('./geolocation/geolocation'));
    }
});